import {IVideoStream} from '@containers/video/videoStreams/types'
import {Box, Card, Chip, IconButton, Stack, Typography} from '@mui/material'
import styles from '@containers/video/videoStreams/list/sx'
import TvIcon from '@mui/icons-material/Tv'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import React from 'react'
import moment from 'moment'

const MAX_PREVIEW_CAMERAS = 4

export const VideoStreamCard = ({
									stream,
									onClickPlay,
									disabled
								}: {
	stream: IVideoStream
	onClickPlay: (stream: IVideoStream) => Promise<void>,
	disabled: boolean
}) => {
	
	const previewCameras = stream.cameras.slice(0, MAX_PREVIEW_CAMERAS)
	
	const getWidth = () => {
		if (previewCameras.length === 1) return '100%'
		return '50%'
	}
	
	return (
		<Card variant="outlined" sx={styles.card}>
			<Box sx={styles.previewBox}>
				<Box sx={styles.statusDot(stream.isActive)}/>
				
				{stream.isActive && (
					<IconButton
						onClick={async () => {
							await onClickPlay(stream)
						}}
						sx={styles.playIcon}
						disabled={disabled}
					>
						<PlayArrowIcon color="primary" fontSize="large"/>
					</IconButton>
				)}
				
				<Stack
					direction="row"
					alignItems="flex-start"
					justifyContent="fle-start"
					flexWrap="wrap"
					sx={{width: '100%', height: '100%'}}
				>
					{previewCameras.map((camera, i) => (
						<Box
							key={camera.cameraId || i}
							sx={{
								width: getWidth(),
								height: previewCameras.length > 2 ? '50%' : '100%',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								outline: '1px solid',
								outlineColor: 'divider',
								overflow: 'hidden'
							}}
						>
							{camera.previewUrl ? (
								<Box
									component="img"
									src={camera.previewUrl}
									sx={{
										width: '100%',
										height: '100%',
										objectFit: 'cover'
									}}
								/>
							) : (
								<TvIcon sx={{color: 'text.disabled', fontSize: 32}}/>
							)}
						</Box>
					))}
				</Stack>
				
				<Box sx={styles.cameraBadge}>
					{stream.cameras.length} кам.
				</Box>
			</Box>
			
			<Box sx={{p: 2}}>
				<Box sx={{display: 'flex', justifyContent: 'space-between', mb: 0.5}}>
					<Typography variant="subtitle1" sx={{fontWeight: 700, lineHeight: 1.2}}>
						{stream.licencePlate}
					</Typography>
					<Typography variant="caption" color="text.secondary">
						ID {stream.deviceId}
					</Typography>
				</Box>
				
				<Chip
					label={stream.cameraType}
					size="small"
					sx={styles.brandChip(stream.cameraType)}
				/>
				
				<Typography variant="caption" display="block" color="text.secondary" sx={{mb: 1, height: 16}}>
					{stream.isActive ? 'В мережі' : 'Активності немає'}
				</Typography>
				
				<Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.3}}>
					{stream.cameras.map((cam) => (
						<Box key={cam.cameraId} sx={styles.tagPaper}>
							{cam.cameraId} {cam.lastSeenAt ? moment(cam.lastSeenAt).format('DD.MM.YYYY,HH:MM') : ''}
						</Box>
					))}
				</Box>
			</Box>
		</Card>
	)
}